<template>
  <base-steps
    ref="stepper"
    hideButtons
    class="d-flex flex-column"
    style="min-height: 100%; align-items: stretch"
  >
    <div>
      <base-card class="pb_0">
        <base-input v-model="searchTerm" placeholder="Pesquisar" search />
      </base-card>

      <div class="row mt_20 box-flavors">
        <div
          class="col-lg-6 col-xs-6"
          v-for="(item, i) in product.items.filter(
            (it) => !searchTerm || it.name.lowerIndexOf(searchTerm) > -1
          )"
          :key="i"
        >
          <!-- <div class="box-selection tooltip" @click="item.quantity > 0 ? decreaseQty(item) : increaseQty(item)"> -->
          <div
            class="box-selection tooltip"
            :style="item.quantity > 0 && 'border-color: #FF3382C9'"
            @click="addProduct(item)"
          >
            <span
              class="tooltip-show"
              @touchstart="goTouchStart()"
              @touchend="goTouchEnd()"
              @touchcancel="goTouchEnd()"
            ><i class="fas fa-info-circle" /></span>
            <span class="tooltiptext">{{ item.name }}</span>
            <p class="name" :style="item.quantity > 0 && 'color: #ff3382'">
              {{ item.name }}
            </p>
            <p class="price">
              {{
                (+getItemPrice(item)).toFormat(StringLanguage.currencyConfigs)
              }}
            </p>
            <!-- <span v-if="item.quantity > 0" class="qty">1</span> -->
          </div>
        </div>
      </div>
    </div>
    <div :class="[2, 3].includes(flavorsItems) ? '' : 'inactive'">
      <base-card>
        <base-question text="Quais vão ser as divisões?" />
        <div
          class="option-step mt_15"
          v-for="(item, index) in product.items.filter((it) => it.quantity > 0)"
          :key="index"
        >
          <p class="item-name">{{ item.name }}</p>
          <base-select
            v-if="flavorsItems == 2"
            v-model="item.division"
            @click.native="setDivision(item)"
            class="ml_10 flex-33 pt_0 mb_0"
          >
            <option :value="'1/2'">1/2</option>

            <option :value="'1/3'">1/3</option>
            <option :value="'2/3'">2/3</option>

            <option :value="'1/4'">1/4</option>
            <option :value="'3/4'">3/4</option>
          </base-select>

          <base-select
            v-else-if="flavorsItems == 3"
            v-model="item.division"
            @change.native="setDivision(item)"
            class="ml_10 flex-33 pt_0 mb_0"
          >
            <option :value="'1/2'">1/2</option>
            <option :value="'1/3'">1/3</option>
            <option :value="'1/4'">1/4</option>
          </base-select>

          <base-select v-else v-model="item.division" class="ml_20 flex-33">
            <option :value="`1/${flavorsItems}`">1/{{ flavorsItems }}</option>
          </base-select>
        </div>
      </base-card>
    </div>
    <div :class="!product.doughs.length ? 'inactive' : ''">
      <base-card>
        <base-question text="Selecione um tipo de massa" />
        <div class="option-step" v-for="(dough, i) in product.doughs" :key="i">
          <base-radio
            :label="dough.name"
            :value="selectedDough"
            :option="`${i}`"
            @click="selectDough(i)"
            :family="'dough'"
          />
          <p class="price-step">
            {{
              (+getItemPrice(dough) || 0).toFormat(
                StringLanguage.currencyConfigs
              )
            }}
          </p>
        </div>
      </base-card>
    </div>
    <div :class="!product.edges.length ? 'inactive' : ''">
      <base-card :card="true">
        <base-question text="Selecione uma borda" />
        <div class="option-step">
          <base-radio
            label="Sem borda"
            :value="selectedEdge"
            :option="''"
            :family="'border'"
            @click="selectEdge(-1)"
          />
        </div>
      </base-card>
      <base-card :defaultCard="false">
        <div class="option-step" v-for="(edge, i) in product.edges" :key="i">
          <base-radio
            :label="edge.name"
            :value="selectedEdge"
            :option="`${i}`"
            @click="selectEdge(i)"
            :family="'border'"
          />
          <p class="price-step">
            {{
              (+getItemPrice(edge) || 0).toFormat(
                StringLanguage.currencyConfigs
              )
            }}
          </p>
        </div>
      </base-card>
    </div>
    <div :class="!product.extra_ingredients.length ? 'inactive' : ''">
      <base-card>
        <base-question text="Extras" />
        <div
          class="option-step"
          v-for="(extra, i) in product.extra_ingredients"
          :key="i"
        >
          <base-checkbox
            :label="extra.name"
            :defaultValue="1"
            v-model="extra.quantity"
            :checked="!!extra.quantity"
            @change="addIngredientExtra"
          />
          <p class="price-step">
            {{
              (+getItemPrice(extra) || 0).toFormat(
                StringLanguage.currencyConfigs
              )
            }}
          </p>
        </div>
      </base-card>
    </div>
    <div
      :class="
        product.extra_ingredients.filter((item) => item.quantity > 0).length ==
        0 || product.items.filter((item) => item.quantity > 0).length == 1
          ? 'inactive'
          : ''
      "
    >
      <base-card
        v-for="(extra, i) in product.extra_ingredients.filter(
          (item) => item.quantity > 0
        )"
        :key="i"
      >
        <base-question :text="`${extra.name} vai em quais sabores?`" />
        <base-checkbox
          v-for="(flavor, i) in product.items.filter(
            (item) => item.quantity > 0
          )"
          :label="flavor.name"
          :key="i"
          :defaultValue="1"
          class="flavors"
          v-on:change="(v, e) => updateExtraFlavor(e, extra, flavor)"
          :checked="
            flavor
              .getItemsByParam('_id', extra._id)
              .every((x) => x.quantity > 0)
          "
        />
      </base-card>
    </div>
    <div>
      <base-card>
        <base-question text="Alguma observação?" />
        <base-textarea
          label="Insira uma observação"
          rows="5"
          v-model="product.observation"
          class="mb_5"
        />
      </base-card>
    </div>
  </base-steps>
</template>
<script>
import BaseSteps from "@/components/Steps";
import BaseCard from "@/components/Card";
import BaseQuestion from "@/components/Question";
import BaseRadio from "@/components/Radio";
import BaseCheckbox from "@/components/Checkbox";
import BaseTextarea from "@/components/Textarea";
import BaseDrawer from "@/components/Drawer";
import BaseButton from "@/components/Button";
import BaseInput from "@/components/Input";
import BaseSelect from "@/components/Select";

import Builder from "easyjs/lib/Schema/Components/Builder";
import Vue from "vue";

export default {
  components: {
    BaseSteps,
    BaseCard,
    BaseQuestion,
    BaseRadio,
    BaseCheckbox,
    BaseTextarea,
    BaseDrawer,
    BaseButton,
    BaseInput,
    BaseSelect,
  },
  data() {
    return {
      searchTerm: null,
      selectedEdge: "",
      selectedDough: "",
      selectedItem: this.product.items[0],
      time: null,
    };
  },
  props: {
    product: { type: Object },
    category: { type: Object },
  },
  mounted() {},
  methods: {
    goTouchStart () {
        let tooltip = event.target.parentNode.nextElementSibling

        this.time = setTimeout(() => {
            tooltip.classList.add('show-tooltip')
        }, 500);
    },
    goTouchEnd () {
        event.target.parentNode.nextElementSibling.classList.remove('show-tooltip')
        clearTimeout(this.time)
    },
    addProduct(item) {
        if (this.product.max_flavors === 1) {
            if (this.selectedItem !== item) {
                if (this.selectedItem.quantity > 0){
                    this.decreaseQty(this.selectedItem)
                }
                this.increaseQty(item)
                this.selectedItem = item
            }
            else {
                this.selectedItem.quantity > 0 ? this.decreaseQty(this.selectedItem) : this.increaseQty(this.selectedItem)
            }
        }
        else {
            item.quantity > 0 ? this.decreaseQty(item) : this.increaseQty(item)
        }

        this.$emit('updatePrice', this.product)
    },
    getAvailableSteps() {
        let availableSteps = [1,1,1,1,1,1,1,1];
        if(true) {
            availableSteps[1] = 1;
        }

        if(!this.product.doughs || this.product.doughs.length == 0) {
            availableSteps[3] = 0;
        }

        if(!this.product.edges || this.product.edges.length == 0) {
            availableSteps[4] = 0;
        }

        if(!this.product.extra_ingredients || this.product.extra_ingredients.length == 0) {
            availableSteps[5] = 0;
            availableSteps[6] = 0;
        } else if(this.product.extra_ingredients.reduce((t, i) => t+i.quantity, 0) == 0 || this.product.items.reduce((t, i) => t+i.quantity, 0) == 1) {
            availableSteps[5] = 1;
            availableSteps[6] = 0;
        }

        return availableSteps;
    },
    next() {
        if(this.$refs.stepper) {
            let currentStep = this.$refs.stepper.current;
            if(currentStep == 1 && this.product.items.reduce((t, i) => t+i.quantity, 0) == 0) {
                alert('Selecione ao menos um sabor de pizza!');
                return false;
            }

            if(currentStep == 1) {
                this.setDefaultDivision();
            }

            if(currentStep == 3 && this.product.doughs.length > 0 && this.product.doughs.reduce((t, i) => t+i.quantity, 0) == 0) {
                alert('Selecione ao menos um tipo de massa!');
                return false;
            }

            if(currentStep == 6) {
                let selectedExtras = new Set(...[this.product.items.reduce((c, i) => [...c, ...(i.extra_ingredients.filter(j => !!j.quantity).map(j => j._id))], [])]);
                if(this.product.extra_ingredients.reduce((t, i) => t+i.quantity, 0) != [...selectedExtras].length) {
                    alert('Os extras devem ser utilizados ao menos um vez!');
                    return false;
                }
            }

            if((currentStep+1) == 2) {
                if (!!(this.$props.product.doughs || []).length) {
                    this.product.doughs[0].quantity = 1;
                    this.$emit('updatePrice', this.product);
                    this.selectedDough = '0';

                    this.$forceUpdate();
                }
            }

            this.$refs.stepper.next();
        }
    },
    prev() {
        if(this.$refs.stepper) {
            let availableSteps = this.getAvailableSteps();
            for(let x = this.$refs.stepper.current - 2; x >= 0; x--) {
                if(availableSteps[x]) {
                    this.$refs.stepper.current = x + 1;
                    return;
                }
            }
            this.$refs.stepper.prev();
        }
    },
    selectEdge (i) {
        this.selectedEdge = i >= 0 ? `${i}` : '';
        this.product.edges.forEach((edge, idx) => {
            edge.quantity = (idx == i) ? 1 : 0
        })
        this.$emit('updatePrice', this.product)
    },
    selectDough (i) {
        this.selectedDough = i >= 0 ? `${i}` : '';
        this.product.doughs.forEach((dough, idx) => {
            dough.quantity = (idx == i) ? 1 : 0
        })
        this.$emit('updatePrice', this.product)
    },
    addIngredientExtra() {
        this.product.items.filter(i => i.quantity > 0).forEach(item => {
            item.extra_ingredients = this.product.extra_ingredients.filter((extra) => extra.quantity > 0).map((extra) => this.cloneObject(extra))
        })
        this.$emit('updatePrice', this.product)
    },
    updateExtraFlavor(event, extra, flavor) {
        flavor.extra_ingredients.forEach(e => {
            if(e._id == extra._id) {
                e.quantity = event.target.checked ? 1 : 0
            }
        });
    },
    cloneObject(obj) {
        return Builder.mountSchema(JSON.parse(JSON.stringify(obj)));
    },
    getItemPrice(item) {
        if(item.sizes.length > 0) {
            return item.sizes[0].price
        }
        return item.price;
    },
    increaseQty(item) {
        if(!item) {
            this.product.quantity += 1
        } else if(item.type == 'flavor') {
            if(this.product.items.reduce((t, i) => t+i.quantity, 0) < this.product.max_flavors) {
                item.quantity += 1
            }
        } else {
            item.quantity += 1
        }
    },
    decreaseQty(item) {
        if(!item) {
            this.product.quantity = Math.min(this.product.quantity-1, 0)
        } else {
            item.quantity = 0;
        }
    },
    setDivision(flavor){
        if(!flavor.division) return;

        // Obtém os outros sabores escolhidos
        const othersFlavors = this.product.items.filter(item => item._id != flavor._id && item.quantity > 0);

        if(this.flavorsItems == 2){
            // Define a quantidade(numerador) do sabor principal
            flavor.quantity = +flavor.division[0];

            // Define a quantidade do segundo sabor com base no resto do primeiro
            othersFlavors[0].quantity = (+flavor.division[2]) - (+flavor.division[0]);

            // Define a fração do segundo sabor em forma literal
            othersFlavors[0].division = `${othersFlavors[0].quantity}/${flavor.division[2]}`;
        }else if(this.flavorsItems == 3 && flavor.division != '1/3'){
            const fractions = flavor.division == '1/2' ? ['1/4', '1/4'] : ['1/2', '1/4'];

            // Define a quantidade do sabor principal
            flavor.quantity = flavor.division == '1/2' ? 2 : 1;

            // Define a quantidade do segundo sabor com base na fração predefinida
            othersFlavors[0].quantity = fractions[0] == '1/2' ? 2 : 1;
            // Define a fração do segundo sabor em forma literal
            othersFlavors[0].division = fractions[0];

            // Define a quantidade do terceiro sabor, que vai ser sempre 1/4
            othersFlavors[1].quantity = 1;
            // Define a fração do terceiro sabor em forma literal
            othersFlavors[1].division = fractions[1];
        }else {
            this.setDefaultDivision();
        }

        this.$emit('updatePrice', this.product);
    },
    setDefaultDivision(){
        this.product.items.filter((item) => item.quantity > 0).forEach(item => {
            item.division = `1/${this.flavorsItems}`;
            item.quantity = 1;
        });

        this.$forceUpdate();
    },
  },
  computed: {
    flavorsQuantity() {
      return this.product.items.reduce((t, i) => t + i.quantity, 0);
    },
    flavorsItems() {
      return this.product.items.filter((item) => item.quantity > 0).length || 0;
    },
  },
};
</script>
<style scoped>
.box-flavors .col-lg-6.col-xs-6:nth-child(1n) {
  padding-right: 5px;
}
.box-flavors .col-lg-6.col-xs-6:nth-child(2n) {
  padding-left: 5px;
  padding-right: 15px;
}
.box-selection {
  background-color: transparent;
  border: 1px solid var(--input-border);
  text-align: center;
  padding: 13px 15px 12px 15px;
  border-radius: 8px;
  margin-bottom: 20px;
  cursor: pointer;
  white-space: nowrap;
  position: relative;
  text-overflow: ellipsis;
  font-size: 1.2em;
  color: #AAAAAB;
  min-height: 75px;
}

@media not all and (pointer: coarse) {
  .box-selection:hover i {
    color: #CCCCCC;
    opacity: .75;
  }
  .box-selection:hover {
    border-color: #FF3382C9;
    transition: all .1s ease;
  }
  .box-selection:hover .name {
    color: var(--default);
  }
}

.box-selection .price {
  margin-top: 10px;
  font-weight: 900;
  color: #CCCCCC;
}

.flavors:not(:last-child) {
  margin-bottom: 15px;
}

.box-selection .name {
  max-width: 100%;
  color: #AAAAAB;
  height: 25px;
  white-space: normal;
  overflow: hidden;
  text-overflow: ellipsis;
  display: flex;
  justify-content: center;
  padding: 0 20px;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

@media screen and (max-width: 991px) {
  .box-selection :is(.price, .name) {
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
}

.box-selection .qty {
  position: absolute;
  top: 5px;
  right: 20px;
  padding: 4px 6px;
  font-size: 0.7em;
  background: var(--default);
  border-radius: 100%;
  color: white;
  font-weight: 900;
}

.option-step {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 25px;
}

.item-name {
  background: #2E2E335C;
  padding: 15px;
  border-radius: 5px;
  color: #AAAAAAED;
  display: flex;
  flex: 0 100%;
  height: 45px;
  font-size: 12px;
  align-items: center;
}

.option-step-none {
  display: none;
}

.price-step {
  font-size: 1.2em;
  color: #AAAAABD4;
}

.tooltip .tooltiptext {
  visibility: hidden;
  position: absolute;
  background: #555;
  color: #fff;
  text-align: center;
  padding: 10px;
  border-radius: 6px;
  z-index: 1;
  bottom: 115%;
  left: 0;
  right: 0;
  opacity: 0;
  transition: opacity 0.3s;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  max-width: 100%;
  margin: auto;
  white-space: normal;
  font-size: 11px;
}

.tooltip .tooltiptext:after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #555 transparent transparent transparent;
}

.tooltip-show i {
  position: absolute;
  right: 15px;
  font-size: 13px;
  color: #5C6066;
}

@media(hover: hover) and (pointer: fine) {
  .tooltip-show:hover + .tooltiptext {
    visibility: visible;
    opacity: 1;
  }
}

.tooltiptext.show-tooltip {
  visibility: visible;
  opacity: 1;
}
</style>